<template>
  <div>
    <v-card class="locationOverview mb-8">
      <v-card-text>
        <div class="header-content">Warehouse Overview</div>
        <div v-if="totalWarehouseRacks">
          <div class="locationOverview__legend mb-8">
            <div>Total Number of racks: <b>{{ totalWarehouseRacks }}</b></div>
            <div>Total Number of shelves: <b>{{ totalWarehouseShelves }}</b></div>
            <div>Total Number of bins: <b>{{ totalWarehouseBins }}</b></div>
          </div>
          <div class="locationOverview__body mb-4">
            <Rack v-for="rack in warehouse.map.racks" :key="rack.id" :rack="rack" @show-bin-items="handleShowBinItems($event)"/>
          </div>
          <v-row>
            <v-col cols="6">
              <div class="locationOverview__legend">
                <div><div class="locationBin" /> available bin</div>
                <div><div class="locationBin itemLoaded" /> loaded bin</div>
              </div>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn
                depressed
                link
                :to="{name: 'EditWarehouse', params: {id: getActiveWarehouse.id}}"
                class="save-btn small-size"
                min-width='260'
              >
                Edit Warehouse Layout
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div v-else class="text-center pt-4 pb-4">
          <p class="pb-4">
            You can set up a warehouse map in your warehouse settings.
          </p>
          <v-btn
            depressed
            link
            :to="{name: 'EditWarehouse', params: {id: getActiveWarehouse.id}}"
            class="save-btn small-size"
            min-width='260'
          >
            Edit Warehouse Layout
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <WarehouseMapBinItemsPopup
      :warehouse='warehouse'
      :rack='showBinItemsPopupRack'
      :shelf='showBinItemsPopupRackShelf'
      :bin='showBinItemsPopupRackShelfBin'
      :binItems='showBinItemsPopupRackShelfBinItems'
      :showPopup='showBinItemsPopup'
      @cancel='handleBinItemsPopupClickOk'
    />
  </div>
</template>

<script>
import WarehouseMapBinItemsPopup from '@/components/warehouses/popups/getWarehouseMapBinItems'
import Rack from '@/components/locations/map/Rack'
import service from '@/services/warehouses'
import { mapGetters } from 'vuex'

export default {
  name: 'LocationOverview',
  components: {
    WarehouseMapBinItemsPopup,
    Rack
  },
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showBinItemsPopupRack: null,
      showBinItemsPopupRackShelf: null,
      showBinItemsPopupRackShelfBin: null,
      showBinItemsPopupRackShelfBinItems: null
    }
  },
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    showBinItemsPopup() {
      return !!this.showBinItemsPopupRack && !!this.showBinItemsPopupRackShelf && !!this.showBinItemsPopupRackShelfBin && !!this.showBinItemsPopupRackShelfBinItems
    },
    totalWarehouseRacks() {
      return this.warehouse.map.racks.length
    },
    totalWarehouseShelves() {
      let totalShelves = 0
      this.warehouse.map.racks.forEach(rack => {
        totalShelves += rack.shelves.length
      })
      return totalShelves
    },
    totalWarehouseBins() {
      let totalBins = 0
      this.warehouse.map.racks.forEach(rack => {
        rack.shelves.forEach(shelf => {
          totalBins += shelf.bins.length
        })
      })
      return totalBins
    }
  },
  methods: {
    async handleShowBinItems(requestData) {
      const payload = {
        warehouseId: this.warehouse.id,
        warehouseRackId: requestData.rack.id,
        warehouseRackShelfId: requestData.shelf.id,
        id: requestData.bin.id
      }

      const response = await service.getWarehouseRackShelfBin(payload)
      if (response?.data?.error?.type === 200) {
        this.showBinItemsPopupRack = requestData.rack
        this.showBinItemsPopupRackShelf = requestData.shelf
        this.showBinItemsPopupRackShelfBin = requestData.bin
        this.showBinItemsPopupRackShelfBinItems = response.data.data
      }
    },
    handleBinItemsPopupClickOk() {
      this.showBinItemsPopupRack = null
      this.showBinItemsPopupRackShelf = null
      this.showBinItemsPopupRackShelfBin = null
      this.showBinItemsPopupRackShelfBinItems = null
    }
  }
}
</script>

<style scoped lang="scss">
.locationOverview {
  .v-card__text {
    padding: 20px 30px;
  }

  .locationOverview__legend {
    display: flex;
    flex-direction: row;
    _border-bottom: 1px solid #efefef;

    > div {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;
      margin-right: 50px;

      .locationBin {
        margin-right: 15px;
      }

      b {
        display: inline-flex;
        padding-left: 5px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
      }
    }
  }

  .locationOverview__body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
